import React from "react";
import { Button } from "antd";
import { Link } from "react-router-dom";
const Approved = () => {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100%",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <img
            alt=""
            src="/pics/MeetMaxEmblemLogo.png"
            style={{ height: "150px" }}
          />
          <br />
          <br />
          <h1 style={{ fontWeight: "bold" }}>Leave Approved Successfully</h1>
          <Link to="/">
            <Button type="primary" style={{ height: "45px" }}>
              Go To Dashboard
            </Button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Approved;
